import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TodoService } from '../../todo.service';
import { ActivatedRoute, Params } from '@angular/router';
import { LocalUserService } from 'app/main/shared/services/localUser';
import * as moment from 'moment';
import { EguardConfirmatialogComponent } from 'app/core/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material';
import { Preference } from '../../preference.model';

@Component({
  selector: 'todo-my-day',
  templateUrl: './my-day.component.html',
  styleUrls: ['./my-day.component.scss']
})
export class MyDayComponent implements OnInit {
  @Input()
  preference: Preference;
  @Input()
  projects: any;

  @Output()
  update: EventEmitter<any> = new EventEmitter();

  tasks: any[] = [];
  task: string;
  date: Date;

  today: Date = new Date();
  note: any;
  priority: string;
  selectedTask: any;
  defaultProject: any

  isLoading = false;
  showIcon = false;
  progress = true;
  userId: string;

  prioritydata = null;
  myTodayList: boolean;
  filteredProjects = [];

  projectData: {
    title: string,
    my_day: Date
  };
  currentDate: Date;

  sortedData = [];
  setPriority: string;
  dialogRef: any;

  constructor(
    private todoService: TodoService,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private localStore: LocalUserService

  ) {
    this.userId = localStore.getUserId()
  }
  ngOnInit() {
    this.setDayList()
  }

  ngOnChanges() {
    if (this.projects) {
      this.defaultProject = this.projects.find(item => item.default === true)
    }
    if (this.projects && this.projects.length) {
      this.tasks = [];
      this.projects.forEach((project) => this.tasks.push(...project.tasks.filter(task => task.my_day)))
    }
    if (this.preference && this.preference.hide_completed_subtask_on) {
      this.projects.hideCompleteTask = true
    }
  }
  hideConfirmationTask(task) {
    if (this.preference.confirm_delete) {
      this.deleteTaskConfirmation(task);
    }
    if (!this.preference.confirm_delete) {
      this.deleteTask(task);
    }
  }
  addNewTask(newData) {
    // let taskDetail;
    // this.progress = true;
    // taskDetail = newData;
    this.projectData = {
      title: newData,
      my_day: new Date()
    };
    this.todoService.addTask(this.userId, this.defaultProject.id, this.projectData).subscribe(
      data => {
        // this.projects.tasks.push(data);
        this.progress = false;
        // this.project.tasks = null;
        this.task = null;
        this.update.emit();
      },
      err => {
        console.log(err);
        this.progress = false;
      }
    );
  }


  stepsComplete(task) {

    return task.steps.filter(step => step.is_completed).length
  }
  updateTask(task) {
    this.progress = true;
    this.todoService
      .updateTask(this.userId, task.list_id, task.id, task)
      .subscribe(data => {
        this.update.emit();
        this.progress = false;
      });

    event.stopPropagation();
  }

  priorityData(event) {
    this.prioritydata = event;
    if (event != null) {
      if (event.value !== 'ALL') {
        this.filteredProjects = this.projects.filter(data => {
          return data.priority === event.value;
        });
      } else {
        this.filteredProjects = this.projects;
      }
    } else {
      this.filteredProjects = this.projects;
    }
  }

  deleteTask(event) {
    this.progress = true;
    this.todoService
      .deleteTask(this.userId, event.list_id, event.id)
      .subscribe(data => {
        this.projects.tasks = this.projects.tasks.filter(task => task.id !== event.id);
        this.priorityData(this.prioritydata);
        this.progress = false;
      });
  }
  getTaskCopy(task, project) {
    this.progress = true;
    this.todoService.copyTask(this.userId, task.list_id, task.id, project.id)
      .subscribe(task => {
        this.update.emit();
        this.progress = false;
      })
  }
  getTaskMove(task, project) {
    this.progress = true;
    this.todoService.moveTask(this.userId, task.list_id, task.id, project.id)
      .subscribe(task => {
        this.update.emit();
        this.progress = false;
      })
  }

  createNewList(task) {
    this.progress = true;
    let model = {
      task_id: task.id,
      list_id: task.list_id
    }
    this.todoService.createNewList(this.userId, model)
      .subscribe(list => {
        this.update.emit();
        this.progress = false;
      })
  }

  getNextPriority(value) {
    if (value == 'LOW') {
      return 'MEDIUM'
    } else if (value == 'MEDIUM') {
      return 'HIGH'
    } else if (value = 'HIGH') {
      return 'LOW'
    }
  }

  changePriority(task) {
    task.priority = this.getNextPriority(task.priority)

    this.updateTask(task)
  }



  setDayList() {
    if (this.projects && this.projects.length) {
      this.tasks = [];
      this.projects.forEach((project) => this.tasks.push(...project.tasks.filter(task => {
        if (task.my_day && moment(task.my_day).isSame(moment(), 'day')) {
          return task;
        }

      })))
    }
    this.sortedData = this.tasks.slice();
    let data = this.sortedData
    this.sortedData = data.sort((a, b) => {
      const isAsc = true;
      return compare(+a.created_date, +b.created_date, isAsc);
    })
  }
  setColor(task) {
    this.currentDate = new Date()
    let dueDate = new Date(task.due_date)
    if (moment(dueDate).startOf('day') < moment(this.currentDate).startOf('day')) {
      return 'red';
    }
  }
  getProjectName(task) {
    let selected = this.projects.find((project => project.id === task.list_id))
    return selected ? selected.name : '';

  }

  addMyDay(task) {
    task.my_day = new Date();
    this.updateTask(task)
  }

  addDueDate(time: string, task) {
    task.due_date = new Date()
    // let currentDate = new Date()
    if (time !== 'today') {
      //   task.due_date = currentDate
      // } else {
      task.due_date = task.due_date.setDate(task.due_date.getDate() + 1).toDate();
    }
    this.updateTask(task)
  }
  deleteTaskConfirmation(task) {
    this.dialogRef = this.dialog.open(EguardConfirmatialogComponent, {
      data: {
        confirmMessage: 'Are you sure want to delete this Task?'
      }
    });
    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.deleteTask(task);
        }
      });
  }


  taskListSort(priority) {
    let tasks = this.tasks
    this.sortedData = []
    this.setPriority = priority
    if (this.projects && this.projects.length) {
      tasks.forEach(task => {
        if (task.priority == this.setPriority) {
          this.sortedData.push(task)
        }
      })
    }
  }

  sortData(sort: string) {
    const data = this.tasks.slice();
    if (!sort) {
      this.sortedData = data;
      return;
    }
    this.sortedData = data.sort((a, b) => {
      const isAsc = true;
      switch (sort) {
        case 'title': return compare(b.title, a.title, isAsc);
        case 'starred': return compare(a.starred, b.starred, isAsc);
        case 'my_day': return compare(+a.my_day, +b.my_day, isAsc);
        case 'HIGH': return compare(b.priority, a.priority, isAsc);
        case 'MEDIUM': return compare(a.priority, b.priority, isAsc);
        case 'LOW': return compare(b.priority, a.priority, isAsc);
        case 'due_date': return compare(+a.due_date, +b.due_date, isAsc);
        case 'is_completed': return compare(a.is_completed, b.is_completed, isAsc);
        case 'creation': return compare(a.creation, b.creation, isAsc);
        default: return 0;
      }
    });
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? -1 : 1);
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/components/my-day/my-day.component.ts